import { useEffect, useMemo, useState } from "react";
import { Paper } from "@mui/material";
import BodyText from "../../../components/BodyText";
import SubTitle from "../../../components/SubTitle";
import styles from "../ActivatingPage.module.css";
import FadingText from "./FadingText";
import signalGif from "../../../assets/signal.gif";
import Title from "../../../components/Title";
import logo from "../../../assets/cosmo-logo-white.svg";

const messages = [
  "Activating plan...",
  "Assembling Avengers...",
  "Accessing the mainframe...",
  "Loading flux capacitor...",
  "Slaying the dragon...",
  "Searching for intelligent life...",
  "Resurrecting the dinosaurs...",
  "Collecting infinity stones...",
  "Phoning home...",
  "Unwrapping golden ticket...",
  "Running with scissors...",
  "Rescuing the princess...",
  "Burning the cookies...",
  "Stealing the moon...",
  "Executing plan Z...",
];

const tips = [
  "Turning on your watch's Wi-Fi helps to provide extra GPS accuracy!",
  "You can also customize preset messages in the parent app that the watch send with a single tap.",
  "Set a SafeZone to be notified when the watch enters and leaves.",
  "Mix and match styles by easily swapping JrTrack wrist bands!",
  "Turn on Class Mode to limit watch functions and reduce distractions during set times.",
  "Hit “Refresh Location” in the Mission Control parent app any time to see your child's current location.",
];
const tipIndex = Math.floor(Math.random() * 6);

const ActivatingView = () => {
  const [messageIndex, setMessageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(
      () => setMessageIndex((prev) => (prev + 1) % messages.length),
      5000
    );

    return () => clearInterval(interval);
  }, []);

  const message = useMemo(() => messages[messageIndex], [messageIndex]);

  return (
    <div className={styles.page}>
      <img src={logo} className={styles.logo} alt="cosmo logo" />

      <Paper
        sx={{
          width: "80%",
          maxWidth: 500,
          borderRadius: 5,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          p: "10px 0 40px 0",
          m: "auto",
          boxShadow:
            "0px 8px 10px 0px #00000024, 0px 11px 15px 0px #00000033, 0px 9px 46px 0px #0000001F, 0px 24px 38px 0px #00000024",
          mb: 6,
        }}
        elevation={3}
      >
        <img
          src={signalGif}
          alt="antenna with alternating signal strength"
          width={200}
        />
        <FadingText message={message ?? ""} />
        <BodyText sx={{ fontWeight: 400, fontSize: "14px", color: "#888072" }}>
          This may take a minute
        </BodyText>
      </Paper>
      <div
        style={{
          width: "80%",
          maxWidth: 500,
          borderRadius: 5,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: "10px 0 40px 0",
          margin: "auto",
        }}
      >
        <Title
          sx={{ fontWeight: 600, fontSize: "24px", color: "#FDF9F2", mb: 1.3 }}
        >
          Pro Tip
        </Title>
        <SubTitle
          sx={{
            fontWeight: 400,
            fontSize: "14px",
            color: "#F0EBE0",
            px: "20px",
          }}
        >
          {tips[tipIndex]}
        </SubTitle>
      </div>
    </div>
  );
};
export default ActivatingView;
